module.exports = __webpack_public_path__ + "media/images/slider006-1ca7158c0c2dad326763574cb6ce2dea.jpg";